const React = require('react');
const T = require('prop-types');
const { default: Styled, withTheme } = require('styled-components');
const PropTypes = require('prop-types');
const ClickOutside = require('react-click-outside');
const { default: Classes } = require('./styles.scss');
const { default: Paper } = require('@mui/material/Paper');
const { default: Typography } = require('@mui/material/Typography');
const PlayStore = require('static/google_play.svg');
const AppStore = require('static/app_store.svg');
const { getOriginalImageUrl } = require('utils/image');
const YouTubePlayer = require('components/YouTubePlayer');

const internals = {};

class WelcomePage extends React.PureComponent {

    static propTypes = {
        isAvailableForAppReview: T.bool,
        onSubmitAppReviewStatus: T.func,
        push: T.func,
        rolePermissions: T.shape({
            id: T.number,
            roleId: T.number,
            schoolId: T.number,
            homeText: T.string
        }),
        schoolWelcomeText: T.string,
        roleHomeTextEnabled: T.bool,
        schoolRoleWelcomeImgUrl: T.string,
        currentUser: T.object,
        hasFirebaseToken: T.bool,
        schoolImg: T.string,
        schoolName: T.string,
        schoolVideoUrls: T.arrayOf(T.string),
        theme: T.object
    }

    constructor(props) {

        super();

        this.state = {
            calloutClosing: false,
            calloutClosed: false
        };

        this.reviewRequested = false;

        this.closingCallout = this._closingCallout.bind(this);
        this.closeCallout = this._closeCallout.bind(this);
    }

    componentDidMount() {

        document.body.classList.add(Classes.welcomeBody);

        this.maybeRequestNativeReview();
    }

    componentDidUpdate(prevProps) {

        const becameAvailable = prevProps
            && prevProps.isAvailableForAppReview !== this.props.isAvailableForAppReview
            && this.props.isAvailableForAppReview;

        if (becameAvailable) {
            this.maybeRequestNativeReview();
        }
    }

    maybeRequestNativeReview = () => {

        if (this.reviewRequested || !this.props.isAvailableForAppReview || !window.cordova) {
            return;
        }

        this.reviewRequested = true;

        const iOSAppId = '1300243604';
        const isAndroid = window.cordova.platformId === 'android';
        const noop = () => {};

        try {
            if (isAndroid) {
                window.cordova.exec(noop, noop, 'AppRate', 'launchReview', []);
            }
            else {
                window.cordova.exec(noop, noop, 'AppRate', 'launchiOSReview', [iOSAppId, true]);
            }

            const { onSubmitAppReviewStatus } = this.props;

            if (onSubmitAppReviewStatus) {
                onSubmitAppReviewStatus('accepted');
            }
        }
        catch (err) {
            this.reviewRequested = false;
            console.warn('[review] error requesting native review:', err);
        }
    };

    componentWillUnmount() {

        document.body.classList.remove(Classes.welcomeBody);
    }

    _closingCallout() {

        this.setState({ calloutClosing: true });
    }

    _closeCallout() {

        this.setState({ calloutClosed: true });
    }

    render() {

        // const { calloutClosed, calloutClosing } = this.state;

        const {
            rolePermissions,
            schoolWelcomeText,
            schoolImg,
            schoolName,
            schoolVideoUrls = [],
            currentUser,
            schoolRoleWelcomeImgUrl,
            hasFirebaseToken,
            roleHomeTextEnabled = true,
            theme
        } = this.props;

        const {
            // isFirstDay, TODO temporarily comment out, it's causing flickering
            firstName
        } = currentUser ?? {};

        const { HeaderText } = internals;

        const isTeamsApp = process.env.APP_FLAVOUR === 'teams';
        const welcomeAccentRgb = internals.getRgb(theme?.palette?.primary?.main);
        const hasSchoolWelcomeHtml = internals.hasHtmlContent(schoolWelcomeText);
        const hasRoleWelcomeHtml = roleHomeTextEnabled
            && internals.hasHtmlContent(rolePermissions?.homeText);
        const schoolVideoEmbeds = schoolVideoUrls
            .filter((url) => !!YouTubePlayer.getEmbedUrl(url));

        // const closed = calloutClosed ? Classes.closed : '';
        // const closing = calloutClosing ? Classes.closing : '';
        return <div
            className={Classes.wrapper}
            style={{ '--welcome-accent-rgb': welcomeAccentRgb }}
        >
            <div className={Classes.main}>
                <div className={Classes.pagePanels}>
                    <Paper className={Classes.headerPaper} elevation={0}>
                        <div className={Classes.headerPaperContent}>
                            <div className={Classes.titleCard}>

                                {/* <HeaderText>{`Welcome${!isFirstDay ? ' Back,' : ','} ${firstName}!`}</HeaderText> */}

                                <HeaderText>{`Welcome, ${firstName}!`}</HeaderText>

                            </div>
                        </div>
                    </Paper>

                    {schoolImg && <Paper className={Classes.welcomePaper} elevation={0}>
                        <div className={Classes.schoolImgContainer}>
                            <img alt={schoolName ? `${schoolName} logo` : 'Community logo'} src={schoolImg} />
                        </div>
                    </Paper>}

                    <Paper className={Classes.welcomePaper} elevation={0}>
                        <div className={Classes.welcomeMessage}>
                            <div className={Classes.welcomeMessageSection}>
                                {hasSchoolWelcomeHtml ? (
                                    <div
                                        className={`${Classes.messageSubpanel} ${Classes.richContent}`}
                                        dangerouslySetInnerHTML={{ __html: schoolWelcomeText }}
                                    />
                                ) : <React.Fragment>
                                    <div className={Classes.messageSubpanel}>
                                        <span>Find, connect, and meet your peers!</span>
                                    </div>
                                </React.Fragment>
                                }
                                {schoolRoleWelcomeImgUrl && <div className={Classes.schoolRoleImgContainer}><img alt={'Community role welcome image'} src={getOriginalImageUrl(schoolRoleWelcomeImgUrl)} /></div>}
                                {hasRoleWelcomeHtml && (
                                    <div
                                        className={`${Classes.messageSubpanel} ${Classes.richContent}`}
                                        dangerouslySetInnerHTML={{ __html: rolePermissions.homeText }}
                                    />
                                )}
                            </div>
                        </div>
                    </Paper>

                    {schoolVideoEmbeds.map((url, index) => (
                        <Paper className={Classes.videoPaper} elevation={0} key={`${url}-${index}`}>
                            <div className={Classes.videoFrame}>
                                <YouTubePlayer
                                    url={url}
                                    title={`${schoolName || 'Community'} video ${index + 1}`}
                                    aspectRatio='4 / 3'
                                    autoPlay={index === 0}
                                />
                            </div>
                        </Paper>
                    ))}
                    {!window.cordova && currentUser?.needsFirebaseToken && !hasFirebaseToken &&
                        <Paper className={Classes.appStorePaper} elevation={0}>
                            <div className={Classes.appStorePaperContent}>
                                <div className={Classes.getAppsButtons}>
                                    {isTeamsApp ?
                                        <React.Fragment>
                                            <a
                                                className={Classes.getAppsButton}
                                                target='_blank'
                                                rel='noopener noreferrer'
                                                href='https://itunes.apple.com/us/app/nearpeer-for-teams/id6445984458'
                                            >
                                                <img alt={'App store logo'} src={AppStore} />
                                            </a>
                                            <a
                                                className={Classes.getAppsButton}
                                                target='_blank'
                                                rel='noopener noreferrer'
                                                href='https://play.google.com/store/apps/details?id=net.nearpeer.app_business'
                                            >
                                                <img alt={'Google Play logo'} src={PlayStore} />
                                            </a>
                                        </React.Fragment> :
                                        <React.Fragment>
                                            <a
                                                className={Classes.getAppsButton}
                                                target='_blank'
                                                rel='noopener noreferrer'
                                                href='https://itunes.apple.com/us/app/nearpeer-for-college-students/id1300243604'
                                                data-focus-outline='radius:5,padding:2,zIndex:1'
                                            >
                                                <img alt={'App store logo'} src={AppStore} />
                                            </a>
                                            <a
                                                className={Classes.getAppsButton}
                                                target='_blank'
                                                rel='noopener noreferrer'
                                                href='https://play.google.com/store/apps/details?id=net.nearpeer.app'
                                                data-focus-outline='radius:5,padding:2,zIndex:1'
                                            >
                                                <img alt={'Google Play logo'} src={PlayStore} />
                                            </a>
                                        </React.Fragment>
                                    }
                                </div>
                                <span>For the best experience, get the Nearpeer app today!</span>
                            </div>
                        </Paper>
                    }
                </div>
            </div>
        </div>;
    }
}

internals.HeaderText = Styled(Typography).attrs({
    variant: 'h1'
})`
    display: block;
    margin: 0;
    font-size: 26px;
    font-weight: 800;
    line-height: 1.12;
    letter-spacing: -0.04em;
    color: #151326;
`;

internals.hasHtmlContent = (html) => {

    if (typeof html !== 'string' || !html.trim()) {
        return false;
    }

    if (/<img[^>]*>/i.test(html)) {
        return true;
    }

    const textOnly = html
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;/gi, ' ')
        .trim();

    return textOnly.length > 0;
};

internals.getRgb = (color) => {

    const defaultRgb = '70, 17, 169';

    if (!color || typeof color !== 'string') {
        return defaultRgb;
    }

    const hex = color.trim().match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i);

    if (hex) {
        const value = hex[1].length === 3 ? hex[1].split('').map((part) => part + part).join('') : hex[1];
        const integer = parseInt(value, 16);

        return `${(integer >> 16) & 255}, ${(integer >> 8) & 255}, ${integer & 255}`;
    }

    const rgb = color.match(/^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i);

    if (rgb) {
        return `${rgb[1]}, ${rgb[2]}, ${rgb[3]}`;
    }

    return defaultRgb;
};

module.exports = withTheme(WelcomePage);
